import React, { useEffect, useState } from "react";
import headingImg from "../../assets/headingImg1.svg";
import CustomGalleryModal from "../custom/CustomGalleryModal";
import axiosStrapiInstance, { baseUrl } from "../../axiosStrapi";
import { toast } from "react-toastify";
import Loader from "../custom/Loader";
import CustomHeading from "../custom/CustomHeading";

const AdmissionGallery = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    getAdmissionImages();
  }, []);

  async function getAdmissionImages() {
    try {
      setLoading(true);

      const response = await axiosStrapiInstance.get(
        "/api/website-images?filters[Type][$eq]=Admission&populate=*"
      );
      setImages(response?.data?.data[0]?.images);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while submiting form", error);
      if (error?.response?.data?.error?.message) {
        toast.error(error?.response?.data?.error?.message);
      } else {
        toast.error("Login failed");
      }
    }
  }
  return (
    <div className="flex flex-col items-center gap-4 py-[2rem] bg-[#FAEDE7] px-[2%] sm:px-[4%] ">
      <CustomHeading
        text={"Our  "}
        spanText={"Gallery"}
        spanTextColor="#d31c4f"
        textSize="60px"
        leading="72px"
        mobileHeartHeight="48px"
        mobileHeartWidth="48px"
        customImg={headingImg}
        heartHeight={"80px"}
        heartWidth={"80px"}
      />
      {loading ? (
        <Loader backgroundColor={"#FAEDE7"} />
      ) : (
        <CustomGalleryModal
          paddingX={"0%"}
          paddingY={"0%"}
          bgColor={"#FAEDE7"}
          Skeletontimer={0}
          images={images?.map((item) => `${item?.url}`)}
        />
      )}
    </div>
  );
};

export default AdmissionGallery;
